module.exports = __webpack_public_path__ + "static/media/logo-shell.7e5401a6.svg";